import { gsap } from "gsap/dist/gsap";

import OptionsAnimImagesProps from "@/interfaces/optionsAnimImages";
import BTIstyles from "@/elements/Shared/BlockTextImage/blocktextimage.module.scss";

export default function scaleXscale(
  imagesTl: any,
  sectionName: string,
  isCircleAnimated: boolean,
  circles?: any,
  optionsAnimImage?: OptionsAnimImagesProps
) {
  if (isCircleAnimated) {
    const circleAnimations = gsap.from(circles, {
      opacity: 0,
    });
    imagesTl.add(circleAnimations);
  }

  if (optionsAnimImage.overlay && optionsAnimImage.overlay.isPresent) {
    switch (optionsAnimImage.overlay.imageNumber) {
      case 1:
        imagesTl
          .from(
            `.${sectionName}-image-${optionsAnimImage.firstImageToAnimate}`,
            {
              opacity: 0,
              transformOrigin:
                optionsAnimImage.transformOriginOrder[
                  optionsAnimImage.firstImageToAnimate
                ],
              onComplete: () => {
                const el = document.querySelector(
                  `.${sectionName}-image-${optionsAnimImage.firstImageToAnimate}`
                );

                el.classList.add(BTIstyles["reveal"]);
              },
            }
          )
          .from(
            `.${sectionName}-image-${optionsAnimImage.lastImageToAnimate}`,
            {
              scale: 0,
              transformOrigin:
                optionsAnimImage.transformOriginOrder[
                  optionsAnimImage.lastImageToAnimate
                ],
            }
          );
        break;
      case 2:
        imagesTl
          .from(
            `.${sectionName}-image-${optionsAnimImage.firstImageToAnimate}`,
            {
              transformOrigin:
                optionsAnimImage.transformOriginOrder[
                  optionsAnimImage.firstImageToAnimate
                ],
              scale: 0,
            }
          )
          .from(
            `.${sectionName}-image-${optionsAnimImage.lastImageToAnimate}`,
            {
              transformOrigin:
                optionsAnimImage.transformOriginOrder[
                  optionsAnimImage.lastImageToAnimate
                ],
              opacity: 0,
              onComplete: () => {
                const el = document.querySelector(
                  `.${sectionName}-image-${optionsAnimImage.overlay.imageNumber}`
                );

                el.classList.add(BTIstyles["reveal"]);
              },
            }
          );
        break;
    }
  }
}
